module.exports = __webpack_public_path__ + "img/00.bd17adff.svg";